import { useBrandingContext } from '../Provider/Context/index.js';
import * as themes from './variables/index.js';
const initTheme = (product) => {
    if (product) {
        return themes[`${product}Theme`];
    }
    return themes.coreTheme;
};
export { initTheme, useBrandingContext };
//# sourceMappingURL=index.js.map